import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export interface AppConfig {
  /**
   * Full URL to the base path of the API. Used to build API requests but also for the AuthHttpInterceptor
   * to identify for which requests the Auth0 token must be added. Must end with a trailing slash!
   */
  baseApiUrl: string;
  /**
   * URL to the new API. Since the frontend and the new backend are currently hosted on a different domain,
   * we must explicitly provide the URL to the new backend (and use it to build the new HTTP requests).
   * Must end with a trailing slash!
   */
  newApiUrl: string;
  /**
   * Auth0 settings. Note that this is duplicated in the settings.json files in the backend.
   */
  auth0: {
    clientID: string;
    domain: string;
    audience: string;
    scope: string;
  },
  sentry: {
    enabled: boolean;
    dsn: string,
    environment: string;
  }
}
